import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { ButtonCloseDialogComponent } from '@component/button-close-dialog/button-close-dialog.component';
import { ButtonCloseComponent } from '@component/button-close/button-close.component';
import { Helper } from '@helpers/helper';
import { CorreoValidator } from '@helpers/validations/email.validator';
import { TelefonoValidator } from '@helpers/validations/telefono.validator';
import { isFalsy } from 'utility-types';

@Component({
  standalone: true,
  imports: [ButtonCloseDialogComponent,MatDialogClose,MatButtonModule,MatDialogModule,ButtonCloseComponent,MatIconModule,MatDividerModule,CommonModule,MatCardModule,],
  selector: 'app-dialog-view-basic-persona',
  templateUrl: './dialog-view-basic-persona.component.html',
  styleUrls: ['./dialog-view-basic-persona.component.css']
})
export class DialogViewBasicPersonaComponent {

  personaForm!: FormGroup
  correoValido!: boolean
  formBuilder: FormBuilder = new FormBuilder;
  constructor(
    public dialogRef: MatDialogRef<DialogViewBasicPersonaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,

  ) {

    this.personaForm = this.formBuilder.group({
      //Persona
      Telefono: ["", Validators.compose([Validators.required])],
      CorreoElectronico: ['', Validators.compose([Validators.required, Validators.email, Validators.maxLength(50)])]
    })

    this.personaForm.controls["Telefono"].setValue(this.data?.telefonoPrincipal);
    this.personaForm.controls["CorreoElectronico"].setValue(this.data.correo);
  }


  copiarAlPortapapeles(texto:string){
    Helper.copyToClipboard(texto)
  }

  sendWhatsApp(){
    let telefonoWS =  this.personaForm.controls["Telefono"].value
    let telefonoValidado = TelefonoValidator.formatPhoneNumber(telefonoWS)

    if(!isFalsy(telefonoValidado))
      TelefonoValidator.sendWhatsApp(telefonoValidado)
  }

  sendEmail(){
    let correoElectronico =  this.personaForm.controls["CorreoElectronico"].value
    CorreoValidator.sendEmail(correoElectronico, this.data.expediente.caratula,"")
  }
}
